import classNames from 'classnames'
import React from 'react'
import ReactDOM from 'react-dom'
import s from './video-viewer.module.scss'
import { CustomVideoPlayer } from '@shared/ui/custom-video-player'

export const VideoViewer = ({url, className, local, isOpen, setOpen}) => {

	if(!isOpen) return

	const src = local ? url : process.env.REACT_APP_STORAGE_URL + url

	return ReactDOM.createPortal(
		<div className={classNames(s.videoWrapper, className)}>
			<div className={s.overview} onClick={() => setOpen(false)}></div>
			<CustomVideoPlayer 
				className={s.videoPlayer}
				wrapperClassName={s.playerContainer}
				src={src}
				autoPlay
				controls
				allowFullscreen
				onClose={() => setOpen(false)}
				skipSeconds={15}
			/>
		</div>,
		document.body
	)
}
